// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__23XLb","itemTitle":"ClientEmergencyInfo_itemTitle__1EkCw","itemText":"ClientEmergencyInfo_itemText__1PeMR"};